import { render, staticRenderFns } from "./AcctNum.vue?vue&type=template&id=ff48cf96&scoped=true&"
import script from "./AcctNum.vue?vue&type=script&lang=js&"
export * from "./AcctNum.vue?vue&type=script&lang=js&"
import style0 from "./AcctNum.vue?vue&type=style&index=0&id=ff48cf96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff48cf96",
  null
  
)

export default component.exports